<template>
    <v-dialog v-model="shows" max-width="720">
        <template #activator="{ attrs, on }">
            <slot name="default" v-bind="{ attrs, on }" />
        </template>

        <template v-if="mode == 'form'">
            <v-card class="v-card--dialog">
                <div class="v-card--dialog__head">
                    <h3 class="tit tit--xs">선물하기</h3>
                    <v-btn fab color="transparent" @click="exit" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <v-divider />
                <div class="v-card--dialog__body">
                    <v-sheet max-width="344" class="mx-auto pa-3">
                        <v-row>
                            <v-col cols="12">
                                <div class="page-text font-weight-bold">교환금액</div>
                                <v-text-field :value="amount.format()" outlined readonly hide-details suffix="원" class="mt-1 text-right" />
                            </v-col>
                            <v-col cols="12">
                                <div class="page-text font-weight-bold">받는사람 번호</div>
                                <v-text-field v-model="giftee.phone" outlined placeholder="‘-’ 없이 번호만 기재" hide-details class="mt-1" />
                            </v-col>
                            <v-col cols="12">
                                <v-row class="row--small primary--text">
                                    <v-col cols="auto"> * </v-col>
                                    <v-col class="page-text page-text--small">
                                        정확한 연락처를 확인 후 보내시기 바라며, <br />
                                        번호 오기재로 인해 발생한 문제는 책임지지 않습니다.
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </div>
                <div class="v-card--dialog__foot d-flex justify-center">
                    <v-btn rounded color="primary" class="w-160px" @click="mode = 'view'">핀 선물하기</v-btn>
                </div>
            </v-card>
        </template>
        <template v-if="mode == 'view'">
            <v-card class="v-card--dialog">
                <div class="v-card--dialog__head">
                    <h3 class="tit tit--xs">입력하신 연락처로 {{ amount.format() }} 캐시를 보내시겠습니까?</h3>
                    <v-btn fab color="transparent" @click="exit" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <v-divider />
                <div class="v-card--dialog__body page-text">
                    <v-sheet max-width="344" class="mx-auto px-3 py-12">
                        <v-row class="row--small">
                            <v-col cols="4" class="font-weight-bold"> 연락처 </v-col>
                            <v-col cols="8"> {{ giftee?.phone?.phoneNumberFormat?.() }} </v-col>
                            <v-col cols="4" class="font-weight-bold"> 보내는 금액 </v-col>
                            <v-col cols="8"> {{ amount.format() }} 원 </v-col>
                        </v-row>
                    </v-sheet>
                </div>
                <div class="v-card--dialog__foot ">
                    <v-row no-gutters>
                        <v-col>
                            <v-row class="row--small primary--text">
                                <v-col cols="auto"> * </v-col>
                                <v-col class="page-text page-text--small">
                                    정확한 연락처를 확인 후 보내시기 바라며, <br />
                                    번호 오기재로 인해 발생한 문제는 책임지지 않습니다.
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="auto">
                            <v-row class="row--small">
                                <v-col cols="auto">
                                    <v-btn color="primary" @click="exec">예</v-btn>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn outlined color="primary" @click="mode = 'form'">아니오</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </template>
    </v-dialog>
</template>

<script>
const initGiftee = (form = {}) => ({
    ...(form || {}),
    phone: form?.phone || null,
});

export default {
    props: {
        amount: { type: Number, default: 0 },
    },
    data: () => ({
        mode: "form",
        shows: false,

        giftee: initGiftee(),
    }),
    methods: {
        init() {
            this.mode = "form";
            this.giftee = initGiftee();
        },
        exit() {
            this.shows = false;
        },
        exec() {
            this.$emit("exec", this.giftee);
        },
    },
    watch: {
        shows(shows) {
            if (shows) this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.text-right {
    & ::v-deep {
        .v-text-field__suffix {
            padding-left: 16px;
        }
        input {
            text-align: end;
        }
    }
}
</style>
